import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { catchError, map, Observable, of } from 'rxjs';

import { APPOINTMENT_ROUTES } from '../consts/appointment-routes.const';
import { SessionService } from '../pages/appointment';

export const logoutGuard: CanActivateFn = (): Observable<UrlTree> => {
  const router: Router = inject(Router);
  const sessionService: SessionService = inject(SessionService);

  return sessionService.logout().pipe(
    map((): UrlTree => router.parseUrl(APPOINTMENT_ROUTES.REDIRECT_URL)),
    catchError((): Observable<UrlTree> => of(router.parseUrl(APPOINTMENT_ROUTES.REDIRECT_URL))),
  );
};
